import { Component } from 'preact';

/**
 * This class is just here to share the hack regarding the dropdown menu with preact.
 * Indeed, preact & preact-compat has an issue preventing the dropdown menu to be displayed.
 * In fact, the event is called twice, which displays the dropdown and then immediately hide it.
 * The hack is just to wait an official fix...
 * https://github.com/developit/preact-compat/issues/306
 */
export abstract class ComponentWithDropdown<Props, State> extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
  }

  horribleDropdownHack(evt: Event) {
    evt.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/common/ComponentWithDropdown.tsx